export default "__VITE_ASSET__BWPxlHN___"